import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { DocumentApiService } from '@icullen/api/document';
import { AnalyticsService, AnalyticsData } from '@icullen/api/shared';

@Component({
  selector: 'icullen-mobile-table',
  templateUrl: './mobile-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./mobile-table.component.scss'],
})
export class MobileTableComponent implements OnInit {
  mobileTableViewData$ = this.route.params.pipe(
    switchMap((params) =>
      this.documentService
        .getTableViewByNameAndUniqueNumber(params.uniqueNumber, params.viewId)
        .pipe(
          tap((data) =>
            this.analyticsService.pushTableViewData(
              data,
              this.router.url,
              data.view.name
            )
          )
        )
    )
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private documentService: DocumentApiService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}
}
